import CityPage from "../CityPage";

export default function PalosHeights() {
  return <CityPage slug="palos-heights" />;
}
